import React from 'react'
import { useTranslation } from 'react-i18next'
import { useInsightContentData } from 'hooks/useInsightModalState'
import messageUtil from 'utils/messageUtil'
import { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import SparklineOverview from 'components/insightContent/visualization/Overview/SparklineOverview'
import { getPercentOfTotal, getMeasureTypeByCountType } from 'components/insightContent/utils/utils'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { useTotalMeasureCount } from 'components/insightContent/hooks'

import RunSearchEffect from './RunSearchEffect'

const MeasureWithInsight = ({
  detailSetting,
  countType
}: {
  detailSetting: InsightContentSettingType
  countType: CountTypeStrings
}) => {
  const { t } = useTranslation()
  const { viewOption } = detailSetting
  const insightContent = useInsightContentData(InsightContentType.MEASURE_WITH_INSIGHTS)
  const total = useTotalMeasureCount()
  const percent = getPercentOfTotal(
    insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0],
    total
  )

  return (
    <UnexpectedErrorBoundary>
      <RunSearchEffect detailSetting={detailSetting} countType={countType}>
        <SparklineOverview
          title={t('countTypeWithViewOption', {
            countType: messageUtil.countType(countType),
            viewOption: messageUtil.viewOption(viewOption)
          })}
          count={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[0]?.dataset?.[0]?.set?.[0]
          }
          percent={percent}
          sparklineData={
            insightContent?.data?.[0]?.results?.[0]?.data?.metrics?.[1]?.dataset?.[0]?.set
          }
          measureType={getMeasureTypeByCountType(countType)}
          status={insightContent?.status}
        />
      </RunSearchEffect>
    </UnexpectedErrorBoundary>
  )
}

export default MeasureWithInsight
